import type { CapabilitySubSelectDto } from '@@types/api.types';

type CapabilityDefinitionSource = Pick<CapabilitySubSelectDto, 'description' | 'name'>;

type CapabilityTooltipItem = CapabilitySubSelectDto & {
  tooltip?: string;
};

export const normalizeCapabilityDefinitionKey = (name: string): string => name.trim().toLowerCase();

export const buildCapabilityDefinitionByName = (capabilities: CapabilityDefinitionSource[]): Map<string, string> => {
  const definitions = new Map<string, string>();

  for (const capability of capabilities) {
    if (capability.description) {
      definitions.set(normalizeCapabilityDefinitionKey(capability.name), capability.description);
    }
  }

  return definitions;
};

export const toCapabilityTooltipItems = (params: {
  definitions: Map<string, string>;
  items: CapabilitySubSelectDto[];
}): CapabilityTooltipItem[] => {
  const { definitions, items } = params;

  return items.map((item) => ({
    ...item,
    tooltip: definitions.get(normalizeCapabilityDefinitionKey(item.name)),
  }));
};
